import { render } from "./AddProject.vue?vue&type=template&id=4e6215d4&ts=true"
import script from "./AddProject.vue?vue&type=script&lang=ts"
export * from "./AddProject.vue?vue&type=script&lang=ts"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__